<template>
  <div style="min-height: calc(100vh - 135px)">
    <div class="bg-cover wrap"></div>
    <div class="z-50 pt-24">
      <div class="text-4xl text-center">电子保函验真平台</div>
      <div class="mb-10 mt-4">
        <div class="p-10 m-auto bg-white rounded-lg shadow-xl" style="width: 648px">
          <a-form 
            :form="form" 
            @submit="handleQuery" 
            :label-col="{ span: 6, offset: 2 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-form-item label="保函编号">
              <a-input
                v-decorator="['code', {
                  rules: [
                    { required: true, message: '请输入保函编号' },
                    { min: 11, message: '保函编号至少11位' }
                  ] 
                }]"
                placeholder="请输入保函编号"
              />
            </a-form-item>
            <a-form-item label="申请人">
              <a-input
                v-decorator="['bidder', { rules: [{ required: true, message: '请输入申请人名称' }] }]"
                placeholder="请输入申请人名称"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }" class="text-center">
              <a-button type="primary" size="large" shape="round" html-type="submit" :loading="loading">
                查询
              </a-button>
            </a-form-item>
            <div class="text-center text-gray-400 mt-6 mb-2">
              温馨提醒：只能用于查询自身保函，不得提供给第三方
            </div>
          </a-form>
        </div>
      </div>
    </div>
    <QueryModal :visible="flag" :info="checkResult" :checkFailed="checkFailed" @cancel="flag = false" />
  </div>
</template>
<script>
  import { queryContract } from '@/api/contract';
  import QueryModal from './module/queryModal.vue';
  export default {
    components: {
      QueryModal,
    },
    data() {
      return {
        form: this.$form.createForm(this, { name: 'check' }),
        loading: false,
        flag: false,
        checkResult: {},
        checkFailed: false
      };
    },
    methods: {
      handleQuery(e) {
        e.preventDefault();
        this.form.validateFields(async (err, values) => {
          if (!err) {
            this.loading = true;
            try {
              this.checkResult = await queryContract(values);
              this.checkFailed = !this.checkResult;
              this.flag = true;
            } catch (err) {
              this.checkResult = {};
              this.checkFailed = true;
              this.flag = true;
            } finally {
              this.loading = false;
            }
          }
        });
      },
    },
  };
</script>
<style scoped>
  .wrap {
    width: 100%;
    background-image: url(https://yldb.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-13/fe4226f8-40b6-4501-a048-211c396aa072.jpg);
    background-repeat: no-repeat;
    position: absolute;
    height: calc(100vh - 276px);
    opacity: 0.2;
    z-index: -1;
  }
  .ant-form-item {
    margin-top: 24px !important;
  }
  :deep(.ant-form label) {
    font-size: 16px !important;
    font-weight: 400;
  }
</style>
